import React, { FC } from 'react'

import { cn } from '@makyoapp/makyo-tw-ui'

interface LayoutDemoProps {
  title: string
  background?: string
  bgColor?: string
  children: React.ReactNode
  opacity?: number
}

export const LayoutDemo: FC<LayoutDemoProps> = ({ title, background, bgColor, children, opacity = 0.65 }) => {
  return (
    <div className='h-full w-full flex flex-col justify-center gap-4'>
      <h2 className='text-2xl font-bold text-[var(--color-on-primary-100)] mb-0'>{title}</h2>
      <section
        className={cn(
          'mk-comp mk-comp-section relative flex flex-col justify-center items-center flex-1 border-[1px] dark:border-gray-700'
        )}
        data-component-type='section'
        style={
          {
            width: 'calc(100% + 0px)',
            height: '416px',
            margin: '0px',
            padding: '25px 16px',
            '--field-color-label': 'var(--color-on-primary-20)',
            '--field-color-bg': 'var(--color-primary-95)',
            '--field-color-fg': 'var(--color-on-primary-95)',
            '--field-color-placeholder': 'color-mix(in oklch, var(--color-on-primary-95) 68%, transparent)',
            '--field-color-accent': 'var(--color-primary-40)',
            '--field-color-on-accent': 'var(--color-on-primary-40)',
            '--field-color-active': 'var(--color-on-primary-95)',
            '--field-color-on-active': 'var(--color-primary-95)',
            '--field-color-focus': 'var(--color-primary-50)',
            '--field-color-thumb': 'var(--color-primary-90)',
            '--field-color-on-thumb': 'var(--color-on-primary-90)',
            '--field-color-checked': 'var(--color-primary-40)',
            '--field-color-unchecked': 'var(--color-primary-10)',
            '--field-color-border': 'var(--color-neutral-60)',
            '--field-color-outline': 'var(--color-neutral-60)',
            '--focus-border': 'var(--color-primary-50)',
            '--focus-ring': 'var(--color-primary-50)',
            '--border-radius': 'var(--radius-md)',
            '--field-label-font': 'var(--typo-label-large-font)',
            '--field-input-font': 'var(--typo-body-medium-font)',
            '--field-supporting-text-font': 'var(--typo-label-small-font)',
            color: 'rgba(0, 0, 0, 0.98)',
            borderRadius: 'var(--radius-md)',
            '--tw-ui-text-active': 'rgba(0, 0, 0, 0.98)',
            zIndex: 0,
          } as React.CSSProperties
        }
      >
        <div
          className='absolute inset-0'
          style={{
            overflow: 'hidden',
            borderRadius: 'inherit',
            zIndex: -1,
            borderTop: '0px solid var(--color-primary-70)',
            borderInlineEnd: '0px solid var(--color-primary-70)',
            borderBottom: '0px solid var(--color-primary-70)',
            borderInlineStart: '0px solid var(--color-primary-70)',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              pointerEvents: 'none',
              zIndex: -5,
              background,
              opacity,
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: '0px',
              left: '0px',
              width: '100%',
              height: '100%',
              pointerEvents: 'none',
              zIndex: -6,
              background: bgColor || 'var(--color-primary-10)',
            }}
          />
        </div>
        {children}
      </section>
    </div>
  )
}
